import { Component, ChangeDetectionStrategy, Input } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { InputBase } from '@app/shared/form/input-base'

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormControlComponent {
  @Input() input: InputBase<string>

  @Input() formGroup: UntypedFormGroup

  get isValid(): boolean {
    return this.formGroup.controls[this.input.key].valid
  }
}
